import { Button } from '@kerfjs/ui/button';
import { List } from '@kerfjs/ui/list';
import { DialogSurface } from '@kerfjs/ui/surface-scaffold';
import { Text } from '@kerfjs/ui/text';
import { TextField } from '@kerfjs/ui/text-field';
import type { SafeHtml } from 'kerfjs';

import { NOTE_MAX_LENGTH } from '../../../../shared/demand-notes.js';

/**
 * Reopen with Update (HS2-Z6MFSA): say what changed about a rejected demand. The update goes to the
 * demand's notes, the rejections are cleared, and the demand returns to the procurement team.
 */
export function ReopenUpdateDialog({ rejected }: { rejected: number }): SafeHtml {
  return (
    <DialogSurface
      label="Reopen with Update"
      lightDismiss
      className="reopen-update-dialog"
      rootAttributes={{ 'data-unsaved-guard': 'this update', 'data-auto-open-dialog': '' }}
      footer={
        <>
          <Button
            size="default"
            tone="neutral"
            emphasis="plain"
            action="reopen-update-cancel"
            rootAttributes={{ 'data-unsaved-cancel': '', 'data-dialog-close': '' }}
          >
            Cancel
          </Button>
          <Button
            size="default"
            tone="brand"
            emphasis="primary"
            action="reopen-update-send"
            rootAttributes={{ 'data-unsaved-save': '' }}
          >
            Reopen
          </Button>
        </>
      }
    >
      <List gap="m">
        <Text variant="p">
          {`Explain what changed or the information you can add. It is posted to the demand's notes, the ${
            rejected === 1 ? 'rejection is' : `${String(rejected)} rejections are`
          } cleared, and the demand goes back to the procurement team to decide again.`}
        </Text>
        <TextField multiline name="reopen-update" label="What Changed" rows={3} maxLength={NOTE_MAX_LENGTH} autofocus />
      </List>
    </DialogSurface>
  );
}
